import { useEffect, useState } from 'react';
import * as React from 'react';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import actions from '@store/actions/listingSearchPage';
import Checkbox from '@components/shared/forms/RawCheckbox';
import { ListingSearchFilterTypes } from '@root/types';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import useHighlightedClick from '../useHighlightedClick';
import s from '../Filters.module.less';

type TermValues = '<1' | '1-3' | '3-5' | '5-10' | '10-15';

type TermOption = {
  value: TermValues;
  name: string;
  translationKey: string;
};

const terms: TermOption[] = [
  {
    value: '<1',
    name: '1 years or less-',
    translationKey: 'filters:term:1orLess',
  },
  {
    value: '1-3',
    name: '1-3 years-',
    translationKey: 'filters:term:1to3',
  },
  {
    value: '3-5',
    name: '3-5 years-',
    translationKey: 'filters:term:3to5',
  },
  {
    value: '5-10',
    name: '5-10 years-',
    translationKey: 'filters:term:5to10',
  },
  {
    value: '10-15',
    name: '10-15 years-',
    translationKey: 'filters:term:10to15',
  },
];

type Props = {
  criteria: ListingSearchCriteria;
  onChange: (criteria: ListingSearchCriteria) => void;
  type: ListingSearchFilterTypes;
};

const TermsFilter = ({ criteria, onChange, type }: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // isHighlighted sets styles only visible in mobile
  const { setHighlighted, isHighlighted } = useHighlightedClick();
  const [selectedTerms, setSelectedTerms] = useState(criteria.terms());

  useEffect(() => {
    setSelectedTerms(criteria.terms());
  }, [criteria]);

  const changeTerms = (term: TermValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const isNowChecked = e.target.checked;
    setHighlighted(term);
    if (isNowChecked) {
      setSelectedTerms([...selectedTerms, term]);
      criteria.addValue('terms', term);
    } else {
      setSelectedTerms(selectedTerms.filter(changedTerm => changedTerm !== term));
      criteria.removeValue('terms', term);
    }
    dispatch(actions.termsFilterChanged(criteria.terms()));
    onChange(criteria);
  };

  return (
    <ul className={s.filterList}>
      {terms.map(({ value, name, translationKey }) => (
        <li
          key={value}
          data-testid={`container-${value}`}
          className={classnames(isHighlighted(value) && s.highlighted)}
        >
          <Checkbox
            className={classnames(s.checkbox)}
            checked={selectedTerms.includes(value)}
            name={`${name}${type}`}
            onChange={changeTerms(value)}
          >
            {t(translationKey)}
          </Checkbox>
        </li>
      ))}
    </ul>
  );
};

export default TermsFilter;
